export const remoteConfigConstants = {
    REMOTE_CONFIG_ROUTES: {
        REMOTE_CONFIG: '/remote-settings/remote-config',
    },
};
